import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PreNotaRoutingModule } from './pre-nota-routing.module';
// tslint:disable-next-line: max-line-length
import { PoPageModule, PoTableModule, PoLoadingModule, PoAccordionModule, PoButtonModule, PoFieldModule, PoDividerModule, PoTabsModule, PoDynamicModule, PoModalModule, PoWidgetModule, PoInfoModule, PoGridModule, PoStepperModule } from '@po-ui/ng-components';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PreNotaListComponent } from './pre-nota-list/pre-nota-list.component';
import { SharedModule } from '../shared/shared.module';
import { PreNotaEditComponent } from './pre-nota-edit/pre-nota-edit/pre-nota-edit.component';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { InterceptorService } from '../authentication/interceptor/interceptor.service';


@NgModule({
  declarations: [PreNotaListComponent, PreNotaEditComponent ],
  imports: [
    CommonModule,
    PreNotaRoutingModule,
    PoPageModule,
    PoTableModule,
    PoStepperModule,
    PoLoadingModule,
    PoAccordionModule,
    FormsModule,
    ReactiveFormsModule,
    PoButtonModule,
    PoFieldModule,
    PoDividerModule,
    PoTabsModule,
    PoDynamicModule,
    PoModalModule,
    PoWidgetModule,
    PoInfoModule,
    SharedModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS, useClass: InterceptorService, multi: true
    }
  ]
})
export class PreNotaModule { }
